import axios from './axios';
import { PATH_DASHBOARD } from '../routes/paths';

// ----------------------------------------------------------------------
// Admin notification bell — Backend_Humblino /api/admin/notifications.
// Read state is per admin, kept by the backend.

export const POLL_INTERVAL_MS = 30 * 1000;

export const fetchNotifications = async ({ page = 1, limit = 20, unread = false } = {}) => {
  const response = await axios.get('/api/admin/notifications', {
    params: { page, limit, ...(unread ? { unread: true } : {}) },
  });
  return response.data; // { items, unreadCount, page, limit, total, totalPages }
};

export const fetchUnreadCount = async () => {
  const response = await axios.get('/api/admin/notifications/unread-count');
  return response.data?.unreadCount ?? 0;
};

export const markNotificationRead = (id) => axios.patch(`/api/admin/notifications/${id}/read`);

export const markAllNotificationsRead = () => axios.patch('/api/admin/notifications/read-all');

/** The admin page a notification opens, or null. */
export const notificationLink = (notification) => {
  const { kind, id } = notification?.link || {};
  if (!id) return null;
  if (kind === 'order') return PATH_DASHBOARD.order.view(id);
  if (kind === 'customer') return PATH_DASHBOARD.customer.detail(id);
  if (kind === 'fit_assistance') return PATH_DASHBOARD.fitAssistance.view(id);
  if (kind === 'appointment') return PATH_DASHBOARD.appointment.view(id);
  // No review detail page yet; open the list.
  if (kind === 'review') return PATH_DASHBOARD.review.list;
  return null;
};

const ICONS = {
  order_placed: { icon: 'eva:shopping-bag-fill', color: 'primary.main' },
  stylist_order_placed: { icon: 'eva:shopping-cart-fill', color: 'info.main' },
  stylist_client_created: { icon: 'eva:person-add-fill', color: 'success.main' },
  customer_signed_up: { icon: 'eva:person-done-fill', color: 'success.main' },
  appointment_booked: { icon: 'eva:calendar-fill', color: 'secondary.main' },
  fit_assistance_requested: { icon: 'eva:alert-circle-fill', color: 'warning.main' },
  fit_remake_ordered: { icon: 'eva:refresh-fill', color: 'error.main' },
  review_submitted: { icon: 'eva:star-fill', color: 'warning.main' },
};

export const notificationIcon = (type) => ICONS[type] || { icon: 'eva:bell-fill', color: 'text.secondary' };
